//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { AbstractProjectModel, AbstractProjectNavModel } from "@app/catalog-common";
import { PresenterRegistration } from "@app/shared";


@PresenterRegistration({
  types: [AbstractProjectNavModel]
})
@Component({
  selector: "project-nav-item",
  standalone: false,
  templateUrl: "./projects-nav-item.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectsNavItemComponent<TProject extends AbstractProjectModel> {
  public data: WritableSignal<AbstractProjectNavModel<TProject>> = signal<AbstractProjectNavModel<TProject>>(null);

  public isActive = computed(() => {
    if(!this.data().items()) return false;
    return this.data().items().some(item => item.isChecked());
  });
}
